<template>
  <footer class="footer mt-auto py-3">
    <div class="footer-row text-muted">
      <span>Copyright © 2021 Archivio Vi.Vo. | All rights reserved | Hosted by Cloud-GARR</span>
    </div>
  </footer>
</template>